import { TagType } from "../../../../constants";
import { useDeleteExerciseTag } from "./useDeleteExerciseTag";
import { useDeleteClientTag } from "../../../coach-clients-tags/mutations/useDeleteClientTag";

interface IDeleteTagProps {
  tagType: TagType;
}

const useDeleteTag = (props: IDeleteTagProps) => {
  const { tagType } = props;
  const deleteExerciseTag = useDeleteExerciseTag();
  const deleteClientTag = useDeleteClientTag();

  switch (tagType) {
    case TagType.EXERCISE:
      return deleteExerciseTag;
    case TagType.CLIENT:
      return deleteClientTag;
    default:
      throw new Error(`Unsupported tag type: ${tagType}`);
  }
};

export default useDeleteTag;
